<template>
    <div class="col-12 col-md-4 col-lg-3 my-3">
        <a :href="web_url+'/presos/'+preso_slug">
            <div class="item-container-preso">
                <div class="item-number">{{ position }}</div>
                <div class="item-img">
                    <img :src="web_url+'/'+image_url" :alt="nombres">
                </div>
                <div class="item-text">{{ nombres }}</div>
            </div>
        </a>
    </div>
</template>

<script>
import { web_url } from '../main.js';
export default {
    name: 'PresoBlock',
    props: {
        image_url: String,
        nombres: String,
        preso_slug: String,
        position: Number
    },
    data() {
        return {web_url: web_url}
    }
}
</script>
